import { Alert, Typography } from '@mui/material'

import useTranslations from '../../../i18n/useTranslations'

import styles from './styles'

const CancelPrintAlert = () => {
  const t = useTranslations()

  return (
    <Alert severity="warning" sx={{ ...styles.alert, ...styles.alertWarning }}>
      <Typography component="p" variant="body2">
        {t('print-alert:cancel-print-alert')}
      </Typography>
    </Alert>
  )
}

export default CancelPrintAlert
